import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CustomShortcutsComponent } from './custom-shortcuts.component';

@NgModule({
  declarations: [CustomShortcutsComponent],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,

    FlexLayoutModule,

    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    MatListModule,
  ],
  exports: [CustomShortcutsComponent],
})
export class CustomShortcutsModule {}
